// eslint-disable-next-line import/prefer-default-export
export function fbqEvent({ event, params }) {
  if (window.fbq) {
    window.fbq('trackCustom', event, params)
  }
}
